// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicy_container__JS0hk","title":"PrivacyPolicy_title__fHJ7f","content":"PrivacyPolicy_content__Z4Yy9"};